import { render } from "./ServiceItemComponent.vue?vue&type=template&id=a1e829d0&scoped=true&ts=true"
import script from "./ServiceItemComponent.vue?vue&type=script&lang=ts"
export * from "./ServiceItemComponent.vue?vue&type=script&lang=ts"

import "./ServiceItemComponent.vue?vue&type=style&index=0&id=a1e829d0&scoped=true&lang=scss"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e829d0"]])

export default __exports__